import { render, staticRenderFns } from "./FriendIcon.vue?vue&type=template&id=24716b64&scoped=true"
import script from "./FriendIcon.vue?vue&type=script&lang=js"
export * from "./FriendIcon.vue?vue&type=script&lang=js"
import style0 from "./FriendIcon.vue?vue&type=style&index=0&id=24716b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24716b64",
  null
  
)

export default component.exports